import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material"
import React, { useEffect } from "react"
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined"
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined"

import { NavLink, useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { getUserRoles } from "../../utils/validateToken"

export const ItemWithSubItems = ({
  item,
  itemSelected,
  setItemSelected,
  level = 0,
}) => {
  const [open, setopen] = React.useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const user = useSelector((state) => state.user)

  useEffect(() => {
    const currentPath = location.pathname.split("/").pop()
    setItemSelected(currentPath)
  }, [location.pathname, itemSelected])

  const isvalidRole = (rolesValidos) => {
    if (!rolesValidos || !Array.isArray(rolesValidos)) {
      return true
    }
    let isvalid = false
    const appRoles = getUserRoles(user.eAuthToken)
    if (appRoles && appRoles.length > 0) {
      appRoles.forEach((element) => {
        if (rolesValidos.includes(element)) isvalid = true
      })
    }
    return isvalid
  }
  const getIndentation = () => {
    if (level === 0) {
      return {}
    }
    return {
      pl: 4 + level * 2,
      marginLeft: `${8 + level * 4}%`,
    }
  }

  const containsSelectedItem = (itemToCheck) => {
    if (itemToCheck.type === itemSelected) {
      return true
    }

    if (itemToCheck.subItems && itemToCheck.subItems.length > 0) {
      const hasSelectedChild = itemToCheck.subItems.some((subItem) =>
        containsSelectedItem(subItem),
      )

      return hasSelectedChild
    }

    return false
  }

  useEffect(() => {
    if (containsSelectedItem(item) && !open) {
      setopen(true)
    }
  }, [itemSelected])
  return (
    <>
      <ListItemButton
        sx={{
          py: 0,
          minHeight: 40,
          color: "rgba(255,255,255,.8)",
          // backgroundColor: item.type === itemSelected ? "#E6E6E6" : null,
          backgroundColor: containsSelectedItem(item) ? "#E6E6E6" : null,
          borderLeft: item.type === itemSelected ? "4px solid #25D9A6" : null,
          ...getIndentation(),
        }}
        onClick={() => setopen(!open)}
      >
        <ListItemIcon sx={{ paddingLeft: "1px" }}>{item.icon}</ListItemIcon>
        <ListItemText
          primary={item.label}
          primaryTypographyProps={{
            fontSize: 16,
            fontWeight: "medium",
            color: "#263057",
          }}
        />
        <ListItemIcon>
          {open ? (
            <ExpandLessOutlinedIcon sx={{ color: "#4B4952" }} />
          ) : (
            <ExpandMoreOutlinedIcon sx={{ color: "#4B4952" }} />
          )}
        </ListItemIcon>
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {item.subItems.map((element) => {
            if (!isvalidRole(element.roles)) return null
            if (element.subItems && element.subItems.length > 0) {
              return (
                <ItemWithSubItems
                  key={element.type}
                  item={element}
                  itemSelected={itemSelected}
                  setItemSelected={setItemSelected}
                  level={level + 1}
                />
              )
            } else {
              return (
                <NavLink
                  key={element.label}
                  to={element.href}
                  style={{ textDecoration: "none" }}
                >
                  <ListItemButton
                    sx={{
                      py: 0,
                      pl: 4 + (level + 1) * 2,
                      minHeight: 40,
                      marginLeft: `${8 + (level + 1) * 4}%`,
                      color: "rgba(255,255,255,.8)",

                      backgroundColor:
                        element.type === itemSelected ? "#E6E6E6" : null,
                      borderLeft:
                        element.type === itemSelected
                          ? "4px solid #25D9A6"
                          : null,
                    }}
                    onClick={() => {
                      setItemSelected(element.type)
                      navigate(element.href)
                    }}
                  >
                    <ListItemIcon>{element.icon}</ListItemIcon>
                    <ListItemText
                      primary={element.label}
                      primaryTypographyProps={{
                        fontSize: 13,
                        fontWeight: "medium",
                        color: "#263057",
                      }}
                    />
                  </ListItemButton>
                </NavLink>
              )
            }
          })}

          {/* isvalidRole(element.roles) && (
                <NavLink
                  key={element.label}
                  to={element.href}
                  style={{ textDecoration: "none" }}
                >
                  <ListItemButton
                    sx={{
                      py: 0,
                      pl: 4,
                      minHeight: 40,
                      marginLeft: "8%",
                      color: "rgba(255,255,255,.8)",
                      backgroundColor:
                        element.type === itemSelected ? "#E6E6E6" : null,
                      borderLeft:
                        element.type === itemSelected
                          ? "4px solid #25D9A6"
                          : null,
                    }}
                    onClick={() => {
                      setItemSelected(element.type)
                      navigate(element.href)
                    }}
                  >
                    <ListItemIcon>{element.icon}</ListItemIcon>
                    <ListItemText
                      primary={element.label}
                      primaryTypographyProps={{
                        fontSize: 14,
                        fontWeight: "medium",
                        color: "#263057",
                      }}
                    />
                  </ListItemButton>
                </NavLink>
              ),
          )} */}
        </List>
      </Collapse>
    </>
  )
}
